export default __webpack_public_path__ + "static/media/yoga-studio.c85ee5ef.jpg";